import { Logo } from '@components/Logo';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const LogoSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Logo"
      description="Sideconvo logo component with auto, black, and white variants. Auto mode (default) switches based on theme."
      figmaNodeId="229-1071"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Auto Variant (Default)</h3>
      <div className={styles.logoBox}>
        <Logo />
      </div>
      <p className={styles.hint}>
        <code>{`<Logo />`}</code> - Automatically switches between black/white based on theme. Toggle the
        theme to see it change.
      </p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Black Variant (Forced)</h3>
      <div className={styles.logoBox}>
        <Logo variant="black" />
      </div>
      <p className={styles.hint}>
        <code>{`<Logo variant="black" />`}</code>
      </p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>White Variant (Forced)</h3>
      <div className={styles.logoBoxDark}>
        <Logo variant="white" />
      </div>
      <p className={styles.hint}>
        <code>{`<Logo variant="white" />`}</code>
      </p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Custom Size</h3>
      <div className={styles.row}>
        <div className={styles.logoBox}>
          <Logo width={65} height={13} />
        </div>
        <div className={styles.logoBox}>
          <Logo width={200} height={40} />
        </div>
      </div>
      <p className={styles.hint}>
        Use <code>width</code> and <code>height</code> props to customize size.
      </p>
    </div>
  </section>
);
